module.exports = __webpack_public_path__ + "img/其他设备.eb6dd2a2.gif";